import React from "react";
import { Button } from "../../../components/ui/button.jsx";
import { ClipboardCopy } from "lucide-react";
import { useToast } from "@/hooks/use-toast.js";

const InfoCard = ({ icon: Icon, label, value, hasCopyToClipboard }) => {

    const { toast } = useToast();

    const copyToClipboard = (text) => {
        let textToCopy = text;

        if (label === 'Phone Number') {
            textToCopy = textToCopy.replace(/-/g, '')
        }

        navigator.clipboard.writeText(textToCopy);
        toast({
            title: 'Copied to clipboard',
            description: textToCopy,
        })
    };

    return (
        <div className="flex items-center bg-gray-50 hover:bg-gray-100 transition-colors p-3 rounded-lg justify-between">
            <div className="flex space-x-3">
                <div className="flex-shrink-0">
                    <Icon className="h-5 w-5 text-gray-500" />
                </div>
                <div>
                    <p className="text-sm font-bold text-gray-500">{label}</p>
                    <p className="text-base font-medium">{value}</p>
                </div>
            </div>
            {hasCopyToClipboard && <Button
                variant="outline"
                className="ml-2"
                onClick={() => copyToClipboard(value)}
            >
                <ClipboardCopy className="h-4 w-4" />
            </Button>}
        </div>
    )
}

export default InfoCard;